
import styled from "styled-components";

const StyledOption = styled.option``;

export default StyledOption;